import * as Types from './ActionTypes';

export const openPopup = (
    open,
    message,
    title,
    action = null,
    detailsTitle,
    detailsId,
    statusCode = 200,
    redirect = null,
    customParam = null,
) => (dispatch) => {
    dispatch({
        type: Types.OPEN_POPUP,
        payload: {
            open,
            message,
            title,
            action,
            detailsTitle,
            detailsId,
            statusCode,
            redirect,
            customParam,
        },
    })
}
export const closePopup = () => (dispatch) => {
    dispatch({
        type: Types.CLOSE_POPUP,
    })
}
